import { render } from "./LookbookTable.vue?vue&type=template&id=61693fc6&scoped=true"
import script from "./LookbookTable.vue?vue&type=script&lang=js"
export * from "./LookbookTable.vue?vue&type=script&lang=js"

import "./LookbookTable.vue?vue&type=style&index=0&id=61693fc6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61693fc6"

export default script